import type {AxiosError} from "axios";
import {isAxiosError} from "axios";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function axiosErrorToString(error: any): string {
    if (isAxiosError(error)) {
        const axiosError: AxiosError = error;
        const contentType = axiosError.response?.headers['content-type'];
        if (typeof contentType === 'string' && contentType.includes('text/html')) {
            // Do not show HTML errors
            return String(axiosError.response?.statusText);
        }
        if (axiosError.response?.data) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const data = axiosError.response?.data as any;
            if (data.message) {
                return String(data.message);
            }
            const keys = Object.keys(data);
            return keys.map(k => `${k}: ${data[k]}`).join(', ');
        }
        if (axiosError.response?.statusText) {
            return String(axiosError.response.statusText);
        }
        if (axiosError.message) {
            return String(axiosError.message);
        }
    }
    if (error) {
        return String(error);
    }
    return 'Unknown error';
}
